import { render } from "./EnhancedSecurity.vue?vue&type=template&id=58c96058&scoped=true"
import script from "./EnhancedSecurity.vue?vue&type=script&lang=js"
export * from "./EnhancedSecurity.vue?vue&type=script&lang=js"

import "./EnhancedSecurity.vue?vue&type=style&index=0&id=58c96058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c96058"]])

export default __exports__